<ng-container *ngTemplateOutlet="dsArrowTpl() || defaultArrowTpl" />

<ng-template #defaultArrowTpl>
    <svg class="ds-arrow-icon" viewBox="0 0 11 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.281018 10.3847L9.28102 19.695L10.719 18.305L2.41443 9.71403L10.6946 1.71939L9.30541 0.280582L0.305412 8.97024C0.114541 9.15453 0.00472972 9.40712 0.000154933 9.6724C-0.00441985 9.93768 0.0966153 10.1939 0.281018 10.3847Z" />
    </svg>
</ng-template>
